// Math utilty functions
export var mathMin = Math.min;
export var mathMax = Math.max;
export var mathAbs = Math.abs;
export var mathCeil = Math.ceil;
export var mathFloor = Math.floor;
export var mathPow = Math.pow;
export var mathRound = Math.round;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/utils/math.js
// module id = 20
// module chunks = 0